import { render } from "./TenantManager.vue?vue&type=template&id=2d2c2d2a"
import script from "./TenantManager.vue?vue&type=script&lang=js"
export * from "./TenantManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__